var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.53503C8.61166 7.53503 8.29688 7.84982 8.29688 8.23816V12.766C8.29688 13.1544 8.61166 13.4692 9 13.4692C9.38834 13.4692 9.70312 13.1543 9.70312 12.766V8.23816C9.70312 7.84982 9.38834 7.53503 9 7.53503Z",
    fill: "#FF7926"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.02528 0 0 4.02564 0 9C0 13.9747 4.02564 18 9 18C13.9747 18 18 13.9744 18 9C18 4.02528 13.9743 0 9 0ZM9 16.5938C4.80259 16.5938 1.40625 13.1971 1.40625 9C1.40625 4.80259 4.80287 1.40625 9 1.40625C13.1974 1.40625 16.5938 4.80287 16.5938 9C16.5938 13.1974 13.1971 16.5938 9 16.5938Z",
    fill: "#FF7926"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.67407C9.52424 6.67407 9.94922 6.24909 9.94922 5.72485C9.94922 5.20061 9.52424 4.77563 9 4.77563C8.47576 4.77563 8.05078 5.20061 8.05078 5.72485C8.05078 6.24909 8.47576 6.67407 9 6.67407Z",
    fill: "#FF7926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f4ee0d5bcd06d77aef828546e8776126.svg";
export { ForwardRef as ReactComponent };